import { configureStore, combineReducers } from '@reduxjs/toolkit';
import TeamReducer, { reducerName as teamReducerName } from './TeamStore';
import PlannedItemReducer, { reducerName as plannedItemReducerName } from './PlannedItemStore';
import PersonReducer, { reducerName as personReducerName } from './PersonStore';
import AllerodnytReducer, { reducerName as allerodnytReducerName } from './AllerodnytStore';
import SlideReducer, { reducerName as slideReducerName } from './SlideStore';
import Tv2NewsReducer, { reducerName as tv2NewsReducerName } from './Tv2NewsStore';
import DrNewsReducer, { reducerName as drNewsReducerName } from './DrNewsStore';
import LorryNewsReducer, { reducerName as lorryNewsReducerName } from './LorryNewsStore';
import FreeTextReducer, { reducerName as freeTextReducerName } from './FreeTextStore';
import WeatherReducer, { reducerName as weatherReducerName } from './WeatherStore';
import WinterDutyReducer, { reducerName as winterDutyReducerName } from './WinterDutyStore';
import CalendarReducer, { reducerName as calendarReducerName } from './CalendarStore';
import GridReducer, { reducerName as gridReducerName } from './GridStore';
import DocumentReducer, { reducerName as documentReducerName } from './DocumentStore';
import AuthReducer, { reducerName as authReducerName } from './AuthStore';
import ResourceReducer, { reducerName as resourceReducerName } from './ResourceStore';
import EventReducer, { reducerName as eventReducerName } from './EventStore';
import AllocatedUnitReducer, { reducerName as allocatedUnitReducerName } from './AllocatedUnitStore';

const rootReducer = combineReducers({
    [teamReducerName]: TeamReducer,
    [plannedItemReducerName]: PlannedItemReducer,
    [personReducerName]: PersonReducer,
    [allerodnytReducerName]: AllerodnytReducer,
    [slideReducerName]: SlideReducer,
    [tv2NewsReducerName]: Tv2NewsReducer,
    [drNewsReducerName]: DrNewsReducer,
    [lorryNewsReducerName]: LorryNewsReducer,
    [freeTextReducerName]: FreeTextReducer,
    [weatherReducerName]: WeatherReducer,
    [winterDutyReducerName]: WinterDutyReducer,
    [calendarReducerName]: CalendarReducer,
    [gridReducerName]: GridReducer,
    [documentReducerName]: DocumentReducer,
    [authReducerName]: AuthReducer,
    [resourceReducerName]: ResourceReducer,
    [eventReducerName]: EventReducer,
    [allocatedUnitReducerName]: AllocatedUnitReducer,
});

export default function configStore(preloadedState) {
    return configureStore({
        reducer: rootReducer,
        preloadedState,
        devTools: process.env.NODE_ENV === 'development',
    });
}